/**
 * Re-exports from the shared jurisdiction hook. The canonical implementation
 * lives in src/hooks/useJurisdictionOptions.ts.
 *
 * The aliases below preserve the names used by SubscriptionForm, SubscriptionDetail,
 * and PackageForm without any behaviour change.
 */
export {
  useJurisdictionOptions as useSubscriptionLocationOptions,
  useJurisdictionOptions as useCountryOptionsBase,
} from "../../../hooks/useJurisdictionOptions";
export type { JurisdictionOption as CountryOption } from "../../../hooks/useJurisdictionOptions";

import { useJurisdictionOptions } from "../../../hooks/useJurisdictionOptions";

/** Backward-compatible wrapper returning all options as a flat list. */
export function useCountryOptions() {
  const { allOptions, loading, error } = useJurisdictionOptions();
  return { countryOptions: allOptions, loading, error };
}
